import { TLocaleTypes } from '~/translations/messages'

const formatLocale = (locale: TLocaleTypes) => locale.split(/[-_]/)[0]

export default formatLocale
